
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

function packlaboAjax() {
  // Private variables
  let userActionModal, cartAvailableProducts, cartUnavailableProductsWrapper, cartUnavailableProducts, cartCount, cartButton, cartTotal,
      allVariantsInputs, cartObject, cartNote, packlaboNumber = 0, packlabosLength, packlaboUnderEditQuantity = 0, packlaboNumberToDuplicate,
      urlQueryAction, urlQueryNumber, packlaboUnderEdit;
  // Private functions
  let init, dispatchPacklaboActions, updateProductsFormOnPageLoad, toggleUserActionModal, eventListeners, productDataToSubmit, submitForm,
      productHasBeenAddedToCart, updateInventory, updatePacklaboCart, setPacklabosNumericInformation, setPacklabosLength, buildPacklaboCart,
      packlaboCartTemplate, updateEventListeners, removeItemFromCart, updateProductFormOnRemove, setPacklaboToIsFull, emptyUnavailableProducts,
      setPacklaboNumberToDuplicate, duplicatePacklabo, shouldPacklaboUnderEditBeEmptied, emptyPacklaboUnderEdit, editPacklabo,
      downgradePacklabos;

  init = function() {
    userActionModal = $("#userActionModal--wrapper");
    cartAvailableProducts = document.getElementById("packLaboSideBar--items");
    cartUnavailableProductsWrapper = $("#packLaboSideBar--itemsUnavailable");
    cartUnavailableProducts = document.getElementById("itemsUnavailableContainer");
    cartCount = document.getElementById("packLaboSidebar--cartCount");
    cartButton = document.getElementById("packLaboSideBar--button");
    cartTotal = document.getElementById("packLaboSideBar--TotalCount");
    allVariantsInputs = [].slice.call(document.getElementsByName("id"));
    eventListeners();
    ShopifyAPI.getCart(cart => [updateProductsFormOnPageLoad(cart), dispatchPacklaboActions(cart)]);
  };

  updateProductsFormOnPageLoad = function(cart) {
    cart.items.forEach(function(item) {
      allVariantsInputs.some(function(subItem) {
        if (subItem.value == item.id) {
          subItem.dataset.qt = Number(subItem.dataset.qt) - Number(item.quantity);
          subItem.checked = false;
          subItem.click();
        }
      })
    });
  };

  dispatchPacklaboActions = function(cart) {
    let urlQueryExists = window.location.search,
        urlQuerySplit = urlQueryExists.substr(1).split("=");

    let isTheQueryInTheCorrectFormat = function(str, num) {
      let editRegExp = RegExp("edit"),
          duplicateRegExp = RegExp("duplicate"),
          isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);
      return (editRegExp.test(str) && str.length == 4) || (duplicateRegExp.test(str) && str.length == 9) && isNumeric(num);
    };

    if (urlQueryExists && isTheQueryInTheCorrectFormat(...urlQuerySplit)) {
      $('html, body').stop(true, true).animate({scrollTop: $("#packLabo--wrapper").offset().top}, 800);
      shouldPacklaboUnderEditBeEmptied(cart, urlQuerySplit);
    }
    else updatePacklaboCart(cart);
  };

  toggleUserActionModal = () => userActionModal.toggleClass("active");

  eventListeners = function() {
    $(".addToPackLaboForms").on("submit", submitForm);
    $("input[type=radio]").on("change", updateInventory);
    cartUnavailableProductsWrapper.find("span").on("click", emptyUnavailableProducts);
    cartButton.addEventListener("click", () => [$("#loadingDivToDestroy").addClass("active"), ShopifyAPI.getCart(cart => setPacklaboToIsFull(cart))]);
  };

  // !IMPORTANT!
  //  When two products of same id have a properties object that is different, the new product is pushed in the items array
  //  instead of being added to the existing object. That allows us to specify to which packlabo a product belongs by
  //  specifying it in the properties object.

  productDataToSubmit = (number, boolean) => `&properties%5B_carry%5D=decorativecase&properties%5BDecorativeCase%5D=${number}&properties%5B_isFull%5D=${boolean}`;

  submitForm = function(e) {
    e.preventDefault();
    let productForm = e.target;

    let isSubmitExceedingPacklaboSize = function() {
      let packlaboTotal = Number(jQuery(productForm).serializeArray()[1].value) + packlaboUnderEditQuantity;
      if (packlaboTotal > 12) {
        let quantityInput = productForm.getElementsByClassName("quantity--wrapper")[0];
        $(quantityInput).addClass('error');
        let button = productForm.getElementsByClassName("submit")[0];
        button.innerHTML += `
          <div id='errorDivToDestroy'>
            <p>Maximum of 12 per Decorative Case. Please add no more than ${12 - packlaboUnderEditQuantity} or remove some thin sheets.</p>
          </div>`;
        setTimeout(() => $("#errorDivToDestroy").remove(), 3000);
        return true;
      } else return false;
    };

    let updateProductFormOnAdd = function() {
      let inputCollection = productForm.id,
          formData = jQuery(productForm).serializeArray(),
          addedVariant = inputCollection.length ? [].slice.call(inputCollection).filter(item => item.value == formData[0].value)[0] : inputCollection;
      addedVariant.dataset.qt = Number(addedVariant.dataset.qt) - Number(formData[1].value);
      addedVariant.checked = false;
      addedVariant.click();
    };

    if (isSubmitExceedingPacklaboSize()) return false;
    ShopifyAPI.packlaboAjax('POST', '/cart/add.js', jQuery(productForm).serialize() + productDataToSubmit(packlaboNumber, false), true, productHasBeenAddedToCart, false, updateProductFormOnAdd);
  };

  productHasBeenAddedToCart = (cartItem, callbacks) => ShopifyAPI.getCart(cart => updatePacklaboCart(cart, callbacks));

  updateInventory = function(e) {
    let dataSetQty = this.dataset.qt,
        productForm = this.closest(".addToPackLaboForms");
    productForm.quantity.value = 1;
    productForm.quantity.max = dataSetQty < 12 ? dataSetQty : 12;
    productForm.getElementsByClassName("addToPackLaboButton")[0].className = dataSetQty == 0 ? "btn addToPackLaboButton" : "btn addToPackLaboButton active";
    productForm.getElementsByClassName("inventory--wrapper")[0].innerHTML = "( "+dataSetQty+" )";
    return false;
  };

  updatePacklaboCart = function(cart, callbacks) {
    cartObject = cart.items;
    [setPacklabosNumericInformation(), buildPacklaboCart(), updateEventListeners()];
    if (callbacks) callbacks.forEach(item => item());
  };

  setPacklabosNumericInformation = function() {
    setPacklabosLength();
    let isThereAPacklaboUnderEdit = cartObject.filter(item => item.properties._carry == "decorativecase" && item.properties._isFull == "false");
    packlaboUnderEdit = isThereAPacklaboUnderEdit.length ? isThereAPacklaboUnderEdit[0].properties.DecorativeCase : null;

    if (!cartObject.length) packlaboNumber = 1;
    else if (!packlaboUnderEdit) packlaboNumber = packlabosLength + 1;
    else packlaboNumber = packlaboUnderEdit;
  };

  setPacklabosLength = function() {
    let gatherAllPacklabosNumbers = [0];
    cartObject.forEach(function(item) {
      let packlaboNumber = item.properties.DecorativeCase;
      if (item.properties._carry == "decorativecase" && !gatherAllPacklabosNumbers.some(value => value == packlaboNumber)) gatherAllPacklabosNumbers.push(+packlaboNumber);
    });
    packlabosLength = Math.max(...gatherAllPacklabosNumbers);
  };

  buildPacklaboCart = function() {
    cartAvailableProducts.innerHTML = "";
    packlaboUnderEditQuantity = 0;
    let allProductsPricesToReduce = [0];
    let loopThroughProductQty = function(qty, price) {
      for (let i = 0; i < qty; i++) allProductsPricesToReduce.push(price);
    };
    cartObject.forEach(function(item, index) {
      if (item.properties._carry == "decorativecase" && item.properties.DecorativeCase == packlaboNumber) {
        packlaboUnderEditQuantity += item.quantity;
        loopThroughProductQty(item.quantity, item.price);
        cartAvailableProducts.innerHTML += packlaboCartTemplate(item, index, true);
      }
    });
    cartCount.innerHTML = packlaboUnderEditQuantity;
    cartButton.className = packlaboUnderEditQuantity == 12 ? "btn active": "btn";
    cartTotal.innerHTML = (allProductsPricesToReduce.reduce((total, value) => total + value) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  packlaboCartTemplate = function(item, index, productIsAvailable) {
    var productTitle = item.product_title
    var productTitle = productTitle.replace('/15-34','')
    return `
      <div class="packLaboSidebar--item${productIsAvailable ? "" : " productIsUnavailable"}">
        <div class="itemImage">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="itemContent--wrapper">
          <h6>${productTitle}</h6>
          <div class="itemContent">
            <p>${item.product_type}</p>
            <p>${item.variant_title} mm</p>
            <p>${item.quantity}</p>
          </div>
        </div>
        ${productIsAvailable ?
          `<div class="itemContent--remove">
            <p data-qty=${0} data-line=${index + 1} data-removed=${item.quantity} data-id=${item.id}>Remove All</p>
            <p data-qty=${item.quantity == 0 ? 0 : item.quantity - 1} data-line=${index + 1} data-removed="1" data-id=${item.id}>Remove One</p>
          </div>` : ``
        }
      </div>
    `;
  };

  updateEventListeners = () => $(".itemContent--remove").on("click", removeItemFromCart);

  removeItemFromCart = function(e) {
    let checkStateOfPacklaboUnderEdit = function(cart, callbacks) {
      cartObject = cart.items;
      if (callbacks) callbacks.forEach(item => item());
      let doesPacklaboUnderEditStillExists = cartObject.some(item => item.properties._carry == "decorativecase" && item.properties.DecorativeCase == packlaboNumber);
      doesPacklaboUnderEditStillExists ? updatePacklaboCart(cart) : downgradePacklabos(cart);
    };

    let dataset = e.target.dataset,
        productData = `quantity=${dataset.qty}&line=${dataset.line}`,
        referenceToThisCallBack = () => updateProductFormOnRemove(dataset.id, +dataset.removed);
    ShopifyAPI.packlaboAjax('POST', '/cart/change.js', productData, true, checkStateOfPacklaboUnderEdit, false, referenceToThisCallBack);
  };

  updateProductFormOnRemove = function(idToCompare, qtyToAdd) {
    allVariantsInputs.some(function(item) {
      if (item.value == idToCompare) {
        item.dataset.qt = +item.dataset.qt + qtyToAdd;
        item.checked = false;
        item.click();
        return true;
      }
    });
  };

  setPacklaboToIsFull = function(cart, callbacks) {
    cartObject = cart.items;
    let productsLeftToUpdate = cartObject.some(function(item, index) {
      if (item.properties._carry == "decorativecase" && item.properties.DecorativeCase == packlaboNumber && item.properties._isFull == "false") {
        let packlaboNumberBeingAddedToCart = packlaboNumber,
            productData = `quantity=${item.quantity}&line=${index + 1}${productDataToSubmit(packlaboNumber, true)}`,
            referenceToThisCallBack = () => setPacklaboNumberToDuplicate(packlaboNumberBeingAddedToCart);
        ShopifyAPI.packlaboAjax('POST', '/cart/change.js', productData, true, setPacklaboToIsFull, false, updatePacklaboCart, emptyUnavailableProducts, referenceToThisCallBack, toggleUserActionModal);
        return true;
      }
    });

    if (!productsLeftToUpdate && callbacks) callbacks.forEach(item => item(cart));
  };

  emptyUnavailableProducts = function() {
    cartUnavailableProductsWrapper.removeClass("active");
    cartUnavailableProducts.innerHTML = "";
  };

  setPacklaboNumberToDuplicate = n => packlaboNumberToDuplicate = n;

  duplicatePacklabo = function() {
    let availableProducts = [],
        notAvailableProducts = [],
        duplicatedProductsInputs = [],
        packlabosNeedToBeDowngraded = packlaboUnderEdit && packlaboUnderEdit != packlabosLength;

    let updateProductFormOnDuplicate = function() {
      duplicatedProductsInputs.forEach(function(item) {
        item.input.dataset.qt = item.input.dataset.qt - item.qtyToSubstract;
        item.input.checked = false;
        item.input.click();
      });
    };

    let setupToDowngradePacklabos = function() {
      ShopifyAPI.getCart(function(cart) {
        cartObject = cart.items;
        setPacklabosLength();
        downgradePacklabos(cart);
      });
    };

    let showUnavailableProducts = function(hijackedCallBacks) {
      cartUnavailableProductsWrapper.addClass("active");
      notAvailableProducts.forEach((item, index) => cartUnavailableProducts.innerHTML += packlaboCartTemplate(item, index, false));
      if (hijackedCallBacks) {//When showUnavailableProducts() comes from a call with no callbacks... Ugly but simplest solution...
        userActionModal.removeClass("active");
        $("#loadingDivToDestroy").removeClass("active");
      }
    };

    let addToCart_isRecursive = function() {
      let productToSubmit = availableProducts.shift(),
          isLastProduct = !availableProducts.length,
          functionParameters = [
            'POST',
            '/cart/add.js',
            `id=${productToSubmit.id}&quantity=${productToSubmit.quantity}${productDataToSubmit(packlabosLength + 1, false)}`,
            isLastProduct ? true : false,
            isLastProduct ? packlabosNeedToBeDowngraded ? setupToDowngradePacklabos : productHasBeenAddedToCart : addToCart_isRecursive,
            false,
            updateProductFormOnDuplicate,
            isLastProduct && notAvailableProducts.length ? showUnavailableProducts : () => undefined
          ];
      if (isLastProduct && userActionModal.hasClass("active")) functionParameters.push(toggleUserActionModal);
      ShopifyAPI.packlaboAjax(...functionParameters);
    };

    cartObject.forEach(function(item) {
      if (item.properties._carry == "decorativecase" && item.properties.DecorativeCase == packlaboNumberToDuplicate) {
        allVariantsInputs.some(function(subItem) {
          if (item.id == subItem.value && item.quantity <= subItem.dataset.qt) {
            availableProducts.push(item);
            duplicatedProductsInputs.push({input: subItem, qtyToSubstract: item.quantity});
            return true;
          } else if (item.id == subItem.value && item.quantity > subItem.dataset.qt) {
            notAvailableProducts.push(item);
            return true;
          }
        });
      }
    });

    setPacklabosLength();
    availableProducts.length ? addToCart_isRecursive() : showUnavailableProducts(true);
  };

  shouldPacklaboUnderEditBeEmptied = function(cart, urlQuery) {
    cartObject = cart.items;
    urlQueryAction = urlQuery[0];
    urlQueryNumber = urlQuery[1];
    setPacklabosNumericInformation();

    let isPacklaboUnderEditTheQuery = cartObject.some(item => item.properties._carry == "decorativecase" && item.properties._isFull == "false" && urlQueryNumber == item.properties.DecorativeCase);

    if (isPacklaboUnderEditTheQuery || urlQueryNumber > packlabosLength || urlQueryNumber == 0) updatePacklaboCart(cart);
    else emptyPacklaboUnderEdit(cart);
  };

  emptyPacklaboUnderEdit = function(cart, callbacks) {
    cartObject = cart.items;
    if (callbacks) callbacks.forEach(item => item());

    let areTheyStillProductsToRemove = cartObject.some(function(item, index) {
      if (item.properties._carry == "decorativecase" && item.properties.DecorativeCase == packlaboUnderEdit) {
        let referenceToThisCallBack = () => updateProductFormOnRemove(item.id, +item.quantity);
        ShopifyAPI.packlaboAjax('POST', '/cart/change.js', `quantity=0&line=${index + 1}`, false, emptyPacklaboUnderEdit, false, referenceToThisCallBack);
        return true;
      }
    });

    if (!areTheyStillProductsToRemove) urlQueryAction == "duplicate" ? [setPacklaboNumberToDuplicate(urlQueryNumber), duplicatePacklabo()] : editPacklabo(cart);
  };

  editPacklabo = function(cart) {
    let recursiveCalls = 0,
        lengthOfProductsToUpdate = cartObject.filter(item => item.properties._carry == "decorativecase" && item.properties.DecorativeCase == urlQueryNumber).length;
    let setPacklaboToEdit = function(cart, callbacks) {
      cartObject = cart.items;
      if (callbacks) callbacks.forEach(item => item());
      let areThereProductsLeftToUpdate = cartObject.some(function(item, index) {
        if (item.properties._carry == "decorativecase" && item.properties.DecorativeCase == urlQueryNumber && item.properties._isFull == "true") {
          ++recursiveCalls;
          let productData = `quantity=${item.quantity}&line=${index + 1}${productDataToSubmit(item.properties.DecorativeCase, false)}`;
          ShopifyAPI.packlaboAjax('POST', '/cart/change.js', productData, recursiveCalls == lengthOfProductsToUpdate ? true : false, setPacklaboToEdit);
          return true;
        }
      });

      if (!areThereProductsLeftToUpdate) !packlaboUnderEdit || packlabosLength == +packlaboUnderEdit ? updatePacklaboCart(cart) : downgradePacklabos(cart);
    };

    setPacklaboToEdit(cart);
  }

  downgradePacklabos = function(cart) {
    let packlaboToDowngrade = +packlaboUnderEdit + 1;

    let downgradeNextPacklabo = function(cart, callbacks) {
      cartObject = cart.items;
      if (callbacks) callbacks.forEach(item => item());
      let areThereProductsLeftToUpdate = cartObject.some(function(item, index) {
        if (item.properties._carry == "decorativecase" && +item.properties.DecorativeCase == packlaboToDowngrade) {
          let productData = `quantity=${item.quantity}&line=${index + 1}${productDataToSubmit(item.properties.DecorativeCase - 1 , item.properties._isFull)}`;
          ShopifyAPI.packlaboAjax('POST', '/cart/change.js', productData, packlaboToDowngrade == packlabosLength ? true : false, downgradeNextPacklabo);
          return true;
        }
      });

      if (!areThereProductsLeftToUpdate) {
        ++packlaboToDowngrade;
        if (packlaboToDowngrade <= packlabosLength) downgradeNextPacklabo(cart);
        else updatePacklaboCart(cart);
      }
    };

    downgradeNextPacklabo(cart);
  };

  init();
  return {
    secondButton: duplicatePacklabo
  };
}

function filtersPacklabo() {
  "use strict";
  // Private variables
  let filterCache = {}, noMatchFoundWrapper, allProducts, allProductsBasicCN, allFiltersCheckboxes, configuratorBanner;
  // Private functions
  let init, eventListeners, filterAllProducts, resetAllProducts, resetFilterCache, toggleNoMatchFound;

  init = function() {
    resetFilterCache();
    noMatchFoundWrapper = $("#filtersForm--noMatchFound");
    allProducts = [].slice.call(document.getElementsByClassName("packLaboProduct"));
    allProductsBasicCN = allProducts[0].className.replace(/active/, '').trim();
    allFiltersCheckboxes = $("#packLabo--wrapper").find('input[type="checkbox"]');
    configuratorBanner = document.getElementById('configurator-banner-wrapper');
  };

  eventListeners = function() {
    allFiltersCheckboxes.change(function(e) {
      let associatedLabel,
          toCache = e.target.name,
          cacheKey = e.target.closest("li").dataset.filter,
          cacheToUpdate = filterCache[cacheKey].indexOf(toCache);
      if ($(this).prev().attr("for") == e.target.id) associatedLabel = $(this).prev();
      if (cacheToUpdate > -1) {
        filterCache[cacheKey].splice(cacheToUpdate, 1);
        if (associatedLabel) associatedLabel.removeClass("active");
      } else {
        filterCache[cacheKey].push(toCache);
        if (associatedLabel) associatedLabel.addClass("active");
      }
      filterAllProducts();
    });
    $("#filtersForm--clearFilters").on("click", () => [resetFilterCache(), resetAllProducts()]);
    // !IMPORTANT!
    // This event listener of "packlabo filters" overwrites line 166 of theme.js.liquid that sets javascript of "catalog filters"
    // To overwrite seemed more straightforward than redo and retest old existing code...
    $('#fil-mob--link').on('click', function() {
      $(this).toggleClass("active");
      $('#fil-mob--wrapper').slideToggle();
    });
  };

  filterAllProducts = function() {
    let aMatchIsFound = false,
        isFilterInColor = item => filterCache.color.length ? filterCache.color.some(itemCache => item.dataset.color.split(",").some(itemData => itemData == itemCache)) : true,
        isFilterInThickness = item => filterCache.thickness.length ? filterCache.thickness.some(itemCache => item.dataset.thickness.split(",").some(itemData => itemData == itemCache)) : true;
    if (filterCache.color.length > 0 || filterCache.thickness.length > 0) {
      configuratorBanner.style.display = "none";
    } else {
      configuratorBanner.style.display = "flex";
    }
    allProducts.forEach(function(item) {
      if (isFilterInColor(item) && isFilterInThickness(item) ) {
        aMatchIsFound = true;
        item.className = allProductsBasicCN + " active";
      } else item.className = allProductsBasicCN;
    });

    toggleNoMatchFound(!aMatchIsFound ? "addClass" : "removeClass");
  };

  resetAllProducts = function() {
    toggleNoMatchFound("removeClass");
    allFiltersCheckboxes.prop("checked", false);
    allProducts.forEach(item => item.className = allProductsBasicCN + " active");
    document.getElementById('filter-by-color--wrapper').querySelectorAll("label").forEach((label, i) => {
      label.classList.remove("active")
    });
  };

  resetFilterCache = function() {
    filterCache.color = [];
    filterCache.thickness = [];
  };

  toggleNoMatchFound = method => noMatchFoundWrapper[method]("active");

  init();
  eventListeners();
}
